import React, { Component } from "react";
import posed from "react-pose";

const Box = posed.div({
  hidden: {
    opacity: 0,
    y: 50,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      opacity: { ease: "linear", duration: 300 },
      default: { ease: "easeOut", duration: 500 }
    }
  }
});

class FadeInUp extends Component {
  state = { visibility: false };

  componentDidUpdate = (prevProps, prevState) => {
    if(prevProps !== this.props){
      if(this.props.fadeIn === true){
        this.changeState(true)
      } else if(!this.props.once) {
        this.changeState(false)
      }
    }
  }

  componentWillUnmount = () => {
    clearTimeout(this.timeoout);
  }

  changeState = (state) => {
    let delay = 300;
    if(this.props.delay){
      delay = this.props.delay;
    }

    this.timeoout = setTimeout(() => {
      this.setState({
        visibility: state
      })
    }, delay);
  }

  render() {
    const { visibility } = this.state;
    return (
        <Box className={`box ${this.props.className}`} pose={visibility ? "visible" : "hidden"}>
          {this.props.children}
        </Box>
    );
  }
}

export default FadeInUp;
